import { GetRequest } from "./RequestHelper";

export const GetProfiles = async () => {
	return GetRequest("profile/all/");
};

export const SearchProfiles = async (query, maxResults) => {
	return GetRequest("profile/search/" + query + "/" + maxResults);
};
